import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { CodeCheckBoxListModel } from '../../../list/code-check-box-list/code-check-box-list.model';
import { CodeListModel } from '../../../list/code-list/code-list.model';
import { ReserveCodeComboBoxModel } from '../reserve-code-combo-box.model';
import { PlessRequest } from "src/app/shared/vo/pless-request.model";

/**
 * コードリストを取得する
 *
 * @export API通信成功時の処理
 * @class GetReserveCodeListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetReserveCodeListService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: ReserveCodeComboBoxModel|CodeCheckBoxListModel|CodeListModel;
  private codeDiv: string = null;
  private reserve1: string = null;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetCodeListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        CodeDiv: this.codeDiv, Reserve1: this.reserve1
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {CodeComboBoxModel|CodeCheckBoxListModel|CodeListModel} model
   * @param {string} codeDiv
   * @param {string} reserve1
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof GetCodeListService
   */
  execute(model: ReserveCodeComboBoxModel|CodeCheckBoxListModel|CodeListModel, codeDiv: string, reserve1: string, successFunc: Function = null) {
      this.model = model;
    this.codeDiv = codeDiv;
    this.reserve1 = reserve1;
    this.successFunc = successFunc;
    this.send('KYMW02getCodeDefinitionList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCodeListService
   */
  success(data: any) {
    this.model.updateCodeList(data);
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }
}
